module.exports = __webpack_public_path__ + "assets/fonts/roboto-v15-latin-ext_latin_greek_cyrillic-300.woff?48b188";


//////////////////
// WEBPACK FOOTER
// ../xod-client/src/core/assets/fonts/roboto-v15-latin-ext_latin_greek_cyrillic-300.woff
// module id = 964
// module chunks = 0